// test2368
(2368 && 0);
